export default __webpack_public_path__ + "resources/icons/d600-97e2.webp";